/**
 * API Configuration
 */

// Determine if we're in production by checking the hostname
const isProduction = typeof window !== 'undefined' && window.location.hostname === 'iqreps.com';

// API base URL
// Production: Custom domain for API Gateway
// Development: Local Express server on port 3000
export const API_BASE_URL = isProduction 
  ? 'https://api.iqreps.com' 
  : 'http://localhost:3000';

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  REGISTER: '/api/auth/register',
  LOGIN: '/api/auth/login',
  ME: '/api/auth/me',
  UPDATE_PROFILE: '/api/auth/profile',
  FORGOT_PASSWORD: '/api/auth/forgot-password',
  RESET_PASSWORD: '/api/auth/reset-password',
  
  // Favorites
  GET_FAVORITES: '/api/auth/favorites',
  ADD_FAVORITE: '/api/auth/favorites',
  REMOVE_FAVORITE: (comboCode) => `/api/auth/favorites/${comboCode}`,
  
  // Progress
  SAVE_ROUND: '/api/progress/round',
  GET_PROGRESS: '/api/progress',
  GET_COMBOS: '/api/progress/combos',
  GET_COMBO: (comboCode) => `/api/progress/combo/${comboCode}`,
  GET_COMBO_HISTORY: (comboCode) => `/api/progress/combo/${comboCode}/history`,
  GET_COMBO_STATS: (comboCode) => `/api/progress/combo/${comboCode}/stats`,
  GET_COMBO_DAILY: (comboCode) => `/api/progress/combo/${comboCode}/daily`,
  
  // Content
  CONTENT: {
    ARTICLES: '/api/content/articles',
    ARTICLE: (slug) => `/api/content/articles/${slug}`,
    PROTOCOLS: '/api/content/protocols',
    PROTOCOL: (slug) => `/api/content/protocols/${slug}`,
  },
  
  // Health
  HEALTH: '/health'
};

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  USER_DATA: 'userData'
};

